import React, { useContext, useEffect, useState, useRef, useCallback } from "react";
import Post from "./Post/Post";
import CategorySelector from "../components/Category/CategorySelector/CategorySelector";
import SubCategorySelector from "../components/Category/CategorySelector/SubCategorySelector/SubCategorySelector";
import StarCategorySelector from "../components/Category/CategorySelector/StarCategorySelector/StarCategorySelector";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import DogWithBoll from "../Assets/Images/dogwithball.gif";

import EventPromo from "../components/Modal/Promotional/EventPromo";
import { LocationContext } from "../CustomHelper/Helper";

import { socketContext } from "../App";
import HomeModal from "../components/CustomModal/HomeModal";
import { Link, useLocation } from "react-router-dom";

const Homepage = () => {
  const [onSelect, setOnSelect] = useState(false);
  const [selectSub, setSelectSub] = useState(false);
  const [selectMain, setSelectMain] = useState(true);
  const [catId, setCatId] = useState(null);
  const [subId, setSubId] = useState(null);
  const [loader, setLoader] = useState(false);

  const [posts, setPosts] = useState([]);
  const [paginate, setPaginate] = useState(1);
  const [status, setstatus] = useState(true);
  const [noData, setNoData] = useState(false);
  const [showSpinModal, setShowSpinModal] = useState(false);

  const { regPromo } = useContext(LocationContext);
  // console.log('recive my promo', regPromo?.eventmode)

  const [starFromIO, setStarFromIO] = useState("");
  const [followStarId, setFollowStarId] = useState("");

  const socketData = useContext(socketContext);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentPostId = searchParams.get('post');
  console.log('currentPostId', currentPostId);
  const fetchData = () => {
    axios
      .get(`api/user/all_post/with-paginate/5?page=${paginate}`)
      .then((res) => {
        setPosts(prev => [...prev, ...res.data.posts]);

        if (res.data.status === 200) {
          setPaginate(paginate + 1);
          setstatus(false);
          if (res.data.posts.length === 0) {
            setNoData(true);
          }
        }
      });
    axios.get("api/user/followers/star").then((res) => {
      if (res.data.status === 200) {
        setFollowStarId(res?.data?.followStarId);
      }
    });

    axios.get(`api/user_info`).then((res) => {
      if (res.data.status === 200) {
        const uinfo = res.data.users;
        if (!uinfo.home_modal_viewed) {
          setShowSpinModal(false);
        }
      }
    });
  };

  const setSelectedPost = useCallback(() => {
    
    if (currentPostId) {
      axios.get(`api/user/all_post/byid/${currentPostId}`)
        .then((res) => {
          setPosts(prev => [...prev, ...res.data.posts]);
        
          if (res.data.status === 200) {
            if (res.data.posts.length === 0) {
              setstatus(false);
              setNoData(true);
            }else{
              fetchData();
            }
          }
          
        }).catch((error) => {
          setstatus(false);
          setNoData(true);
          console.error("Error fetching matched video:", error);
          
        });
    }

  }, [currentPostId]);

  const FeedRefresh = () => {
    setPosts([]);
    setPaginate(1);
    setStarFromIO("");
    setNoData(false);
  };

  useEffect(() => {
    if(currentPostId && paginate === 1) {
      setSelectedPost();
    }else if (paginate === 1) {
      fetchData();
    }
  }, [paginate]);

  socketData.on("starId", (data) => {
    if (followStarId?.includes(parseInt(data))) {
      setStarFromIO(parseInt(data));
    }
  });

  return (
    <>
      {/* {regPromo?.isReg && <EventPromo />} */}
      {/* {selectSub && !onSelect ? (
        <StarCategorySelector
          onSelect={onSelect}
          setOnSelect={setOnSelect}
          selectSub={selectSub}
          setSelectSub={setSelectSub}
          subId={subId}
          setSubId={setSubId}
          catId={catId}
          setCatId={setCatId}
          setPosts={setPosts}
          setstatus={setstatus}
        />
      ) : null} */}

      {/* {onSelect && !selectMain ? (
        <SubCategorySelector
          onSelect={onSelect}
          setOnSelect={setOnSelect}
          catId={catId}
          setCatId={setCatId}
          selectSub={selectSub}
          setSelectSub={setSelectSub}
          subId={subId}
          setSubId={setSubId}
          selectMain={selectMain}
          setSelectMain={setSelectMain}
          setPosts={setPosts}
          setstatus={setstatus}
        />
      ) : null} */}

      {/* {selectMain ? (
        <CategorySelector
          onSelect={onSelect}
          setOnSelect={setOnSelect}
          catId={catId}
          setCatId={setCatId}
          selectMain={selectMain}
          setSelectMain={setSelectMain}
          setPosts={setPosts}
          setstatus={setstatus}
        />
      ) : null} */}
      {starFromIO && (
        <div className="text-center sticky-top">
          <button
            className="btn btn-sm btn-warning mt-3 "
            onClick={FeedRefresh}
          >
            <i class="fas fa-sync fa-fw" title="Refresh"></i> New Posts
          </button>
        </div>
      )}

      <InfiniteScroll
        dataLength={posts.length}
        next={fetchData}
        hasMore={true}
        loader={
          noData ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={DogWithBoll} style={{ height: 250, width: 500 }} />
              <h4 className="text-center text-warning">
                No activity found yet
              </h4>
            </div>
          ) : (
            <div className="text-center">
              <i className="fas fa-spinner fa-pulse text-warning"></i>&nbsp;
            </div>
          )
        }
        endMessage={
          <p style={{ textAlign: "center" }}>
            <b>You have seen it all</b>
          </p>
        }
      >
        <Post style={{ minHeight: "30vh" }} posts={posts} status={status} />
      </InfiniteScroll>

      <HomeModal
        sx={{
          backgroundColor: "black",
          p: 3,
          py: 2,
          height: "60vH",
          overflow: "auto",
          width: { xs: "70%", sm: "40%" },
          color: "rgb(194, 194, 194)",
          zIndex: 200,
          borderRadius: 5,
        }}
        open={showSpinModal}
      >
        <Link
          to="/lucky-spin?refer=modal_home"
        >
           <img
            src="/homeModalPromotion.gif"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: 5,
            }}
          />
        </Link>
      </HomeModal>
    </>
  );
};

export default Homepage;
